import {
  IPostWorkHistoryVerificationParams,
  IWorkHistoryVerification,
} from '@src/models/WorkHistoryVerification'
import { IPayload } from '@src/models/Global'
import { Endpoints } from '../config/endpoints'
import { AxiosService } from '../config/config'

export class WorkHistoryVerificationApi {
  constructor(private axios: AxiosService) {}

  postWorkHistoryVerification = async (params: IPostWorkHistoryVerificationParams) => {
    const response = await this.axios.post<IPayload<IWorkHistoryVerification>>(
      Endpoints.postWorkHistoryVerification,
      params
    )
    return response
  }
}
